import {useEffect, useMemo, useRef, useState} from "react";
import {useTranslation} from "react-i18next";

import ButtonsActions from "views/utils/buttonsActions";
import TopBarActions from "components/TopBarActionsFree";
import RouteMoochTable from "./RouteMoochTable";
import ModalModMassiveMooch from "./ModalModMassiveMooch";
import BoxFiltersMooch from "./BoxFiltersMooch";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import ItemsModel from "core/itemsModel";
import OrderingModel from "components/ordering/OrderingModel";
import {SwalAlertClass, SwalAlertChoice} from "core/swalClass";
import RouteMoochModel from "site-apps/distribution/route/RouteMoochModel";
import ConditionalRender from "components/ConditionalRender";
import axiApi from "ApiCaller";
import {subscribeEvent, unsubscribeEvent} from "core/eventsConnector";

const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
const AlertQuestion = new SwalAlertChoice({
    confirmButtonText: "Aceptar",
    cancelButtonText: "Cancelar",
});

const ViewRoutesMooch = ({keyTab, setKeyTab}) => {
    const {t: _Tt} = useTranslation("tables");
    const [buttonsTB, setButtonsTB] = useState(() => {
        const buttonsAct = new ButtonsActions();
        buttonsAct.title = "Bolseo";
        return buttonsAct;
    });
    const [itemsShown, setItemsShown] = useState([]);
    const [item, setItem] = useState({...RouteMoochModel});
    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());
    const [isLoading, setIsLoading] = useState(false);
    const [showModalMassive, setShowModalMassive] = useState(false);
    const headersTable = useMemo(
        () => [
            {name: _Tt("common.created"), attr: 0, direction: "asc", active: true, default: true},
            {name: _Tt("common.island"), attr: 1, direction: "asc", active: false},
            {name: _Tt("routes.zone"), attr: 2, direction: "asc", active: false},
            {name: _Tt("users.driver"), attr: 3, direction: "asc", active: false},
            {name: _Tt("common.route"), attr: 4, direction: "asc", active: false},
            {name: _Tt("common.cleared"), attr: 5, direction: "asc", active: false, style: {textAlign: "center", width: "80px"}},
        ],
        [_Tt],
    );

    useEffect(() => {
        onMounted(keyTab);
        subscribeEvent("view:route-mooch:apply-filters", customEventApplyFilters);
        return () => {
            unsubscribeEvent("view:route-mooch:apply-filters", customEventApplyFilters);
        };
    }, [keyTab]);

    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        const buttons = {...buttonsTB};
        buttons.filter.applied = true;
        setButtonsTB(buttons);
        applyFilters();
    };

    function onClickFilter() {
        const buttons = {...buttonsTB};
        buttons.filter.click = !buttonsTB.filter.click;
        buttons.counter = items.current.showed.length;
        setButtonsTB(buttons);
    }

    const onMounted = (keyTab_) => {
        if (keyTab_ !== "mooch") return;
        if (itemsShown.length) {
            applyFilters();
            return;
        }
        const buttons = {...buttonsTB};
        buttons.title = "Bolseo";
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        buttons.filter.active = true;
        buttons.filter.onClick = onClickFilter;
        buttons.filter.applied = Object.keys(filters.current.chosen).length > 0;
        setButtonsTB({...buttons});
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            applyFilters();
        };
        items.current.setItem = () => {};
        items.current.setShowPrev = () => {};
        items.current.item = {};
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => applyFilters();

        fetchGetData();
    };

    const fetchGetData = async () => {
        setIsLoading(true);
        const resp = await axiApi.get("/api/distribution/routes/mooch/");
        if (resp.data) {
            items.current.setShowed(resp.data.items);
            setItemsShown([...resp.data.items]);
            if (resp.data.pager) {
                pagerModelRef.current.paging.update(resp.data.pager);
            }
        }
        setIsLoading(false);
    };

    const onClickEdit = () => {
        if (items.current.chosen.length === 0) {
            return false;
        }
        setShowModalMassive(true);
    };

    const onClickDelete = () => {
        AlertQuestion.warning(
            "Se eliminarán los bolseos seleccionados",
            `Se borrarán los ${items.current.chosen.length} seleccionados`,
        ).then((resp) => {
            if (resp.isConfirmed) {
                let ids = items.current.getChosenIds();
                setIsLoading(true);
                axiApi
                    .delete("/api/distribution/routes/mooch/delete/", {data: {ids}})
                    .then((resp) => {
                        if (resp.data.status) {
                            Alert.success("Eliminados", "Bolseos eliminados correctamente");
                        }
                    })
                    .catch((error) => {
                        const msg = error.response?.data?.message || "Error al eliminar los bolseos";
                        Alert.error("Error", msg);
                    })
                    .finally(() => {
                        items.current.clearChosen();
                        const buttons = {...buttonsTB};
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        setButtonsTB(buttons);
                        setIsLoading(false);
                        applyFilters();
                    });
            }
        });
    };

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/routes/mooch/", filters.current.chosen, {
                params: {
                    ...pagerModelRef.current.paging.getParams(),
                    ...orderingRef.current.getParams(),
                },
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShown([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.active = true;
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const customEventApplyFilters = (e) => {
        applyFilters();
        setKeyTab("mooch");
    };

    return (
        <>
            <TopBarActions actions={buttonsTB} filtersRef={filters} className="sticky-top" style={{top: "72px"}} />
            <BoxFiltersMooch filters={filters} show={buttonsTB.filter.click} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />
            <div className="col-12">
                <LoaderSpinner isLoading={isLoading}>
                    <RouteMoochTable
                        items={items}
                        itemsShown={itemsShown}
                        setItemsShown={setItemsShown}
                        setButtonsTB={setButtonsTB}
                        buttonsTB={buttonsTB}
                        orderingRef={orderingRef}
                    />
                </LoaderSpinner>
            </div>
            <ConditionalRender condition={showModalMassive}>
                <ModalModMassiveMooch
                    show={showModalMassive}
                    setShow={setShowModalMassive}
                    items={items}
                    setItemsShow={setItemsShown}
                />
            </ConditionalRender>
        </>
    );
};
export default ViewRoutesMooch;
